import { useState, useEffect, createRef } from "react";
import Chart from "chart.js/auto";
import PieChartConfig from "./PieChartConfig";
import { STATUS_TYPE_CHART_MAPPINGS } from "../../../../utils/constants/StatusType.constants";

const DisplayPieChartByJenjang = ({
  jenjangType,
  dataByJenjang,
  titleChart,
}) => {
  const [chart, setChart] = useState(null);

  const labels = [];
  const dataChart = [];
  let totalData = 0;

  function getStatistikByJenjang() {
    if (!dataByJenjang) return;

    for (const [key, sidangTypeString] of Object.entries(jenjangType)) {
      labels.push(sidangTypeString);

      const value = dataByJenjang[key];
      dataChart.push(value);
      totalData += value;
    }

    return { labels: labels, data: dataChart };
  }

  const chartRef = createRef();

  useEffect(() => {
    if (chartRef.current) {
      const ctx = chartRef.current.getContext("2d");

      if (chart != null) {
        chart.destroy();
      }

      const statistik = getStatistikByJenjang();

      const successChart = new Chart(
        ctx,
        PieChartConfig(titleChart, "Total", statistik, totalData)
      );

      setChart(successChart);
    }
  }, [dataByJenjang]);

  return (
    <div className="max-w-xs">
      <div className="justify-items-center">
        <canvas ref={chartRef} />
      </div>

      <div className="pt-9">
        <div>
          <b>{`Jenis MK Spesial (${
            dataByJenjang.total_izin_maju_sidang +
            dataByJenjang.total_belum_izin_maju_sidang
          })`}</b>
          {Object.keys(jenjangType).map((key) => (
            <p key={key}>{`${jenjangType[key]}: ${dataByJenjang[key]}`}</p>
          ))}
        </div>
        <div className="pt-3">
          <b>Izin Maju Sidang</b>
          <p>{`Total diizinkan: ${dataByJenjang.total_izin_maju_sidang}`}</p>
          <p>{`Total belum diizinkan: ${dataByJenjang.total_belum_izin_maju_sidang}`}</p>
        </div>
        <div className="pt-3">
          <b>Status MK Spesial</b>
          {Object.keys(STATUS_TYPE_CHART_MAPPINGS).map((key) => (
            <p key={key}>{`${STATUS_TYPE_CHART_MAPPINGS[key]}: ${dataByJenjang[key]}`}</p>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DisplayPieChartByJenjang;
